// extracted by mini-css-extract-plugin
export default {"panel-mobile":"font-toolbar_panel-mobile__l1fI9","drawer-body-overflow-visible":"font-toolbar_drawer-body-overflow-visible__g82v0"};